import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from "rxjs";
import { environment } from '../../../../environments/environment';
import { id } from 'date-fns/locale';
import * as moment from 'moment';
const _ = require('lodash');

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  private SERVER_URL = `${environment.API_URL}`;

  constructor(private httpClient: HttpClient) { }

  public login(username, password) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-auth/companyAuth/login',
      {
        username,
        password
      },
      { headers });
  }

  public sendResetRequest(email:string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-auth/companyAuth/resetRequest',
      { email },
      { headers });
  }

  public resetPassword(token:string, password:string) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-auth/companyAuth/resetPassword',
      { token, password },
      { headers });
  }

  public createCompany(company: any, userId = null) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company/company/createCompany',
        { company },
        { headers });
  }

  public updateCompany(company: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company/company/updateCompany',
        { company },
        { headers });
  }

  public isUniqCompany(identification: any, id: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company/company/isUniqCompany',
        { identification, id },
        { headers });
  }

  public getCompanies(search: string): Observable<any> {
    const params = new  HttpParams()
      .set('_search', search);

    return this.httpClient.get(this.SERVER_URL + 'company/company/getCompanies', {params});
  }

  public getCompaniesHavingSupplierInvoices(params: any): Observable<any> {
     const httpParams = Object.keys(params)
      .filter(k => params[k] != null)
      .reduce((p, k) => p.set(k, params[k]), new HttpParams());
  
    return this.httpClient.get(`${this.SERVER_URL}company/company/getCompaniesHavingSupplierInvoices`, { params: httpParams });
  }

  public getCompaniesHavingCompanyInvoices(params: any): Observable<any> {
     const httpParams = Object.keys(params)
      .filter(k => params[k] != null)
      .reduce((p, k) => p.set(k, params[k]), new HttpParams());
  
    return this.httpClient.get(`${this.SERVER_URL}company/company/getCompaniesHavingCompanyInvoices`, { params: httpParams });
  }

  public getMyCompanyData(): Observable<any> {
    const params = new  HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'company/company/getMyCompanyData', {params});
  }

  public getCompanyAppendixes(){
    const params = new  HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'company/company/getCompanyAppendixes', {params});
  }

  public getCompanyAppendixTypes(){
    const params = new  HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'company/company/getCompanyAppendixTypes', {params});
  }

  public deleteCompanyAppendix(appendixId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company/company/deleteCompanyAppendix',
        { id: appendixId },
        { headers });
  }

  public getCompanyAppendixFile(fileId) {
    const params = new HttpParams()
      .set('id', fileId)

    return this.httpClient.get(this.SERVER_URL + 'company/company/getCompanyAppendixFile', {params});
  }


  public uploadCompanyAppendixFile(filename:string, file:string, appendixTypeId:any, documentType:any, documentId:any, documentNumberFull:any) {
   
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company/company/uploadCompanyAppendixFile',
        {filename, file, appendixTypeId, documentType, documentId, documentNumberFull},
        { headers });
  }

  public getCompanyById(companyId: string): Observable<any> {
    const params = new  HttpParams()
        .set('companyId', companyId);

    return this.httpClient.get(this.SERVER_URL + 'company/company/getCompanyById', {params});
  }

  public deleteCompany(companyId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company/company/deleteCompany',
        { companyId },
        { headers });
  }

  public getCompanyProfile(): Observable<any> {
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getCompanyProfile');
  }

  public getCompanyCasierii(): Observable<any> {
    const params = new  HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getCompanyCasierii', {params});
  }

  public getFirstCompanyReceiptForEachBankAccount(): Observable<any> {
    const params = new  HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'company-invoices/companyInvoices/getFirstCompanyReceiptForEachBankAccount', {params});
  }

  public getFirstCompanyReceiptForEachSeries(): Observable<any> {
    const params = new  HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'company-invoices/companyInvoices/getFirstCompanyReceiptForEachSeries', {params});
  }

  public getCompanyBankAccounts(): Observable<any> {
    const params = new  HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getCompanyBankAccounts', {params});
  }

  public addCompanyCasierie(name, contContabil, soldInitial, soldInitialDate, currency, exchangeRate, isActive) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/addCompanyCasierie',
        { name, contContabil, soldInitial, soldInitialDate, currency, exchangeRate, isActive },
        { headers });
  } 

  public deleteCompanyCasierie(id) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/deleteCompanyCasierie',
        { id },
        { headers }); 
  }

  public canDeleteBankAccount(id) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/canDeleteBankAccount',
        { id },
        { headers });
  }

  public updateCompanyCasierie(id, name, contContabil, soldInitial, soldInitialDate, currency, exchangeRate, isActive) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/updateCompanyCasierie',
        { id, name, contContabil, soldInitial, soldInitialDate, currency, exchangeRate, isActive },
        { headers });
  }

  public getLoggedUser(): Observable<any> {
    return this.httpClient.get(this.SERVER_URL + 'company-user/companyUser/getLoggedUser');
  }

  public getCompanyLogo(): Observable<any> {
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getCompanyLogo');
  }

  public getContactInfo(): Observable<any> {
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/contact');
  }

  public saveCompanyProfile(profile: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/saveCompanyProfile',
        { profile },
        { headers });
  }

  public getDispozitiiSeries(): Observable<any> {
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getDispozitiiSeries');
  }

  public getNextDispozitieNumberPreview(series: string) {
    const params = new HttpParams().set('series', series);
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getNextDispozitieNumberPreview', { params });
  }

  public updateShowDeletedArticles(toggle: boolean) {
    let showDeletedArticles = toggle ? 'true' : '';
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/updateShowDeletedArticles',
        { showDeletedArticles },
        { headers });
  }

  public getAvailableAccounts(): Observable<any> {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getAvailableAccounts', {params});
  }

  public switchAccount(companyProfileUuid: string) {
    const params = new  HttpParams()
      .set('companyProfileUuid', companyProfileUuid);

    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/switchAccount', {params});
  }

  public getCompanyClient(): Observable<any> {
    const params = new  HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getCompanyClient', {params});
  }

  public goToClientAccount(userId: string, token: string) {
    const params = new  HttpParams()
      .set('userId', userId)
      .set('token', token);

    return this.httpClient.get(this.SERVER_URL + 'public-ascon/publicAscon/goToClientAccount', {params});
  }

  public sagaUpdate() {
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'company/company/sagaUpdate', {params});
  }

  public getSupportTickets(){
    const params = new  HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'support-tickets/SupportTickets/getSupportTickets', {params});
  }

  public createSupportTicket(ticket){
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'support-tickets/SupportTickets/createSupportTicket',
        { ticket },
        { headers });
  }

  public updateSupportTicket(ticket){
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'support-tickets/SupportTickets/updateSupportTicket',
        { ticket },
        { headers });
  }

  public getClientWorksheets(){
    const params = new  HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getClientWorksheets', {params});
  }

  public downloadPayrollPdfByFilename(filename){
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-profile/companyProfile/downloadPayrollPdfByFilename',
      { filename },
      { headers, responseType: 'blob', observe: 'response' as 'body' });
  }

  public getDataFromVies(countryValue: string, fiscalCode: string): Observable<any> {
    const params = new HttpParams()
        .set('countryValue', countryValue)
        .set('fiscalCode', fiscalCode);
    return this.httpClient.get(this.SERVER_URL + 'company/company/getDataFromVies', {params});
  }

  public getTopArticlesSold(filter: {
    startTime: Date,
    endTime:   Date,
    orderBy:   any,
    orderDir:  'ASC' | 'DESC'
  }): Observable<any> {
    const startSec = Math.floor(filter.startTime.getTime() / 1000);
    const endSec   = Math.floor(filter.endTime.getTime()   / 1000);

    const params = new HttpParams()
      .set('startTime', startSec.toString())
      .set('endTime',   endSec.toString())
      .set('orderBy',   filter.orderBy)
      .set('orderDir',  filter.orderDir);
  
    return this.httpClient.get(
      `${this.SERVER_URL}company-articles/CompanyArticles/getTopArticlesSold`,
      { params }
    );
  }

  public getSellingInfoForArticleId(articleId: any, startTime:any, endTime:any) : Observable<any> {
    const startSec = moment(startTime).startOf('day').unix();
    const endSec   = moment(endTime).endOf('day').unix();

    const params = new HttpParams()
      .set('articleId', articleId)
      .set('startTime', startSec.toString())
      .set('endTime',   endSec.toString());

    return this.httpClient.get(this.SERVER_URL + 'company-articles/CompanyArticles/getSellingInfoForArticleId', {params});
  }
  
  public getRaportProfitProdus(articleId, gestiuneId, from, to) : Observable<any> {
    const fromUnix = moment(from).startOf('day').unix();
    const toUnix   = moment(to).endOf('day').unix();

    const queryParams = {
      'from': fromUnix,
      'to': toUnix,
    } 

    if (articleId) {
      queryParams['articleId'] = articleId;
    }

    if (gestiuneId) {
      queryParams['gestiuneId'] = gestiuneId;
    }

    let params = new HttpParams({fromObject: queryParams})

    return this.httpClient.get(this.SERVER_URL + 'company-profile/CompanyProfile/getRaportProfitProdus', {params});
  }

  public getRaportVanzari(from, to, page, pageSize, extra?: { companyId?: any; search?: string }) {
    const fromUnix = moment(from).startOf('day').unix();
    const toUnix   = moment(to).endOf('day').unix();

    const queryParams: any = {
      'from': fromUnix,
      'to': toUnix,
      'page': page,
      'pageSize': pageSize,
    } 

    if (extra?.companyId) queryParams.companyId = extra.companyId;
    if (extra?.search) queryParams.search = extra.search;

    const params = new HttpParams({fromObject: queryParams})
    return this.httpClient.get(this.SERVER_URL + 'company-profile/CompanyProfile/getRaportVanzari', {params});
  }

  public getUserManuals(): Observable<any> {
    const params = new HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'company/Company/getUserManuals', {params});
  }
  
  public downloadPdfManual(manual: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company/Company/downloadPdfManual',
      { manual }, { headers });
  }

  public newDispozitiePlata(payload) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-dispozitie-plata/CompanyDispozitiePlata/newDispozitie',
      { payload },
      { headers });
  }
  
  public markDispozitieAsPrinted(dispozitieId) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-dispozitie-plata/CompanyDispozitiePlata/markDispozitieAsPrinted',
      { id: dispozitieId },
      { headers });
  }

  public getDispozitieDateLimits(series: string, number: number, paymentId?: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });

    return this.httpClient.post(
      this.SERVER_URL + 'company-account-payable/CompanyAccountPayable/getDispozitieDateLimits',
      {
        series,
        number,
        paymentId: paymentId || null
      },
      { headers }
    );
  }

  isStornoReasonUsed(stornoReasonId: string) {
    return this.httpClient.get(
        this.SERVER_URL + 'company-profile/CompanyProfile/isStornoReasonUsed', 
        { params: new HttpParams().set('stornoReasonId', stornoReasonId) }
    );
  }
  
  getInventoryForArticleGestiune(articleId, gestiuneId) {
    return this.httpClient.get(
        this.SERVER_URL + 'company-profile/CompanyProfile/getInventoryForArticleGestiune', 
        { params: new HttpParams().set('articleId', articleId).set('gestiuneId', gestiuneId) }
    );
  }
}
